/**
 * Component: sa-faq-list
 * Description: FAQ 手风琴 Web Component，支持平滑过渡动画
 */
if (!customElements.get('sa-faq-list')) {
  class SaFaqList extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.details = this.querySelectorAll('details');
      this.details.forEach(detail => {
        const summary = detail.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', this.handleClick);
        }
      });
      this.applyPdfLinkStyles();
    }

    applyPdfLinkStyles() {
      const pdfLinks = this.querySelectorAll('.accordion__content a[href$=".pdf"]');
      const iconTpl = this.querySelector('#sa-faq-pdf-icon-tpl');
      pdfLinks.forEach(link => {
        link.classList.add('sa-faq-list__pdf-link');
        if (iconTpl && iconTpl.content) {
          const icon = iconTpl.content.cloneNode(true);
          link.insertBefore(icon, link.firstChild);
        }
      });
    }

    disconnectedCallback() {
      // 清理事件监听
      if (this.details) {
        this.details.forEach(detail => {
          const summary = detail.querySelector('summary');
          if (summary) {
            summary.removeEventListener('click', this.handleClick);
          }
        });
      }
    }

    handleClick(e) {
      e.preventDefault();
      const summary = e.currentTarget;
      const details = summary.parentElement;
      const content = summary.nextElementSibling; // accordion__content

      if (!content) return;

      // 如果当前是关闭状态，准备展开
      if (!details.hasAttribute('open')) {
        // 设置 open 属性
        details.setAttribute('open', '');
        
        // 获取内容的高度
        const height = content.offsetHeight;
        
        // 初始状态：高度为 0
        content.style.height = '0px';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.3s ease-out';
        
        // 强制重绘
        content.offsetHeight;
        
        // 最终状态：设置实际高度
        content.style.height = `${height}px`;
        
        // 动画结束后清理内联样式
        content.addEventListener('transitionend', () => {
          content.style.height = '';
          content.style.overflow = '';
          content.style.transition = '';
        }, { once: true });

      } else {
        // 如果当前是展开状态，准备收起
        // 获取当前高度
        const height = content.offsetHeight;
        
        // 设置初始高度，以便进行过渡
        content.style.height = `${height}px`;
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.3s ease-out';
        
        // 强制重绘
        content.offsetHeight;
        
        // 最终状态：高度为 0
        content.style.height = '0px';
        
        // 动画结束后移除 open 属性
        content.addEventListener('transitionend', () => {
          details.removeAttribute('open');
          content.style.height = '';
          content.style.overflow = '';
          content.style.transition = '';
        }, { once: true });
      }
    }
  }

  customElements.define('sa-faq-list', SaFaqList);
}
